"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var reducers = {
    isInternetConnected: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_INTERNET_CONNECTED] = function (state, action) { return action.payload; },
        _a), true),
    internetSource: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SET_INTERNET_SOURCE] = function (state, action) { return action.payload; },
        _b), ''),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map